import { useTranslation } from 'react-i18next'
import { useAcknowledged } from '../data/acknowledgements.ts'
import { Pill } from './components.tsx'

/** M16-I2: the sand pill "Version non lue" beside a procedure on a job and on the timer, for the person acting on this device (the workstation's unlocked person),
 *  only when the procedure asks for a reading ("demander une lecture", off by default) and this person has not recorded "J'ai lu cette version" for THIS version.
 *  Read from the device's copy, offline; a reading just recorded here takes it away at once. Never a refusal: the job starts all the same, and a reading is
 *  not a competence. Nothing at all otherwise (most procedures ask nothing). */
export function AckPill({ versionId, testId = 'ack-pill' }: { versionId: string | null | undefined; testId?: string }) {
  const { t } = useTranslation()
  const a = useAcknowledged(versionId)
  if (!a.ready || !a.asks || !a.personId || a.reading) return null
  return (
    <p className="flex flex-wrap items-center gap-2" data-testid={testId} data-version={versionId ?? ''}>
      <Pill tone="amber">{t('ack.unread')}</Pill>
      <span className="meta">{t('ack.unreadHint')}</span>
    </p>
  )
}
